import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Edit = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.903 2.52c-2.796-2.8-7.19-2.8-9.987 0l-3.495 3.5-24.367 24.4c-.1.1-.2.3-.3.4v.1l-3.694 12c-.1.4-.1.8.2 1.1.399.4.798.4 1.198.4h.1l4.494-1.4 7.59-2.3c.199 0 .299-.1.399-.3l27.862-27.9c2.796-2.8 2.796-7.3 0-10Zm-36.45 38.4-2.797.9 2.697-8.8 6.091 6.1-5.992 1.8Zm7.889-2.7-6.99-7.1L29.22 8.22l7.09 7.1-22.968 22.9Zm27.163-27.2-2.697 2.7-7.09-7.1 2.796-2.8c1.898-2 5.093-2 6.99 0 1.898 2.1 1.898 5.3 0 7.2Z"
  }));
});
Edit.displayName = 'Edit';
Edit.defaultProps = {
  'aria-label': 'Edit'
};
export default Edit;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Edit.js
// module id = 3774
// module chunks = 11